import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HEADER_INTRO_TEXT_CONVERTER_TOKEN, HeaderIntroTextConverter } from './header-intro-text.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        headerIntroTextFeature: {
          module: () => import('./header-intro-text.module').then((m) => m.HeaderIntroTextModule),
          cmsComponents: ['header_intro_text'],
        },
      }
    }),
    {
      provide: HEADER_INTRO_TEXT_CONVERTER_TOKEN,
      useExisting: HeaderIntroTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        header_intro_text: HEADER_INTRO_TEXT_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HeaderIntroTextFeatureModule {}
